(() => {
  const openerMap = new WeakMap();

  function openDialog(btn) {
    const id = btn.getAttribute('aria-controls');
    if (!id) return;

    const dialog = document.getElementById(id);
    if (!dialog) return;

    openerMap.set(dialog, btn);

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      // fallback if <dialog> not supported
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }

    const opener = openerMap.get(dialog);
    if (opener) opener.focus();
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-sizechart-open]');
    if (openBtn) {
      e.preventDefault();
      openDialog(openBtn);
      return;
    }

    const closeBtn = e.target.closest('[data-sizechart-close]');
    if (closeBtn) {
      e.preventDefault();
      const dialog = closeBtn.closest('dialog,[open]');
      closeDialog(dialog);
      return;
    }

    // click on backdrop closes (only when clicking the dialog itself, not its content)
    const dialog = e.target instanceof Element ? e.target.closest('dialog') : null;
    if (dialog && e.target === dialog) {
      closeDialog(dialog);
    }
  });

  // ESC is handled by <dialog> natively; this ensures focus returns correctly
  document.addEventListener('close', (e) => {
    const dialog = e.target;
    if (dialog && dialog.tagName === 'DIALOG') {
      const opener = openerMap.get(dialog);
      if (opener) opener.focus();
    }
  }, true);
})();
